import { constants } from '../config';

const initialState = {
  services: [],
  loading: false,
  error: null,
  lineServiceDetail: null,
  lineServiceDetailLoading: false,
  lineServiceDetailError: null,
};

const setLineServicesReducer = (state = initialState, action) => {
  switch (action.type) {
    case constants.GET_LINE_SERVICES:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case constants.GET_LINE_SERVICES_SUCCESS:
      return {
        ...state,
        loading: false,
        services: action.payload,
        error: null,
      };
    case constants.GET_LINE_SERVICES_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case constants.GET_LINE_SERVICE_DETAIL:
      return {
        ...state,
        lineServiceDetailLoading: true,
        lineServiceDetailError: null,
        lineServiceDetail: null,
      };
    case constants.GET_LINE_SERVICE_DETAIL_SUCCESS:
      return {
        ...state,
        lineServiceDetailLoading: false,
        lineServiceDetail: action.payload,
        lineServiceDetailError: null,
      };
    case constants.GET_LINE_SERVICE_DETAIL_ERROR:
      return {
        ...state,
        lineServiceDetailLoading: false,
        lineServiceDetailError: action.payload,
      };
    default:
      return state;
  }
};

export default setLineServicesReducer;
